import type { MemberRole } from './organization';

/**
 * Thin-multi RBAC (see docs/design/… delta spec): OWNER/ADMIN can do everything
 * structural/financial; MEMBER (assistant teacher) can only view + mark
 * attendance. This map is the single source of truth for both the API
 * (`requirePermission` middleware) and the FE (hide/disable gated actions).
 */
export type Permission =
  | 'manage:subjects'
  | 'manage:slots'
  | 'manage:enrollments'
  | 'manage:sessions'
  | 'run:billing'
  | 'manage:invoices'
  | 'manage:bookkeeping'
  | 'manage:students'
  | 'manage:clients'
  | 'manage:settings'
  | 'manage:members';

const ADMIN: MemberRole[] = ['OWNER', 'ADMIN'];

export const PERMISSIONS: Record<Permission, MemberRole[]> = {
  'manage:subjects': ADMIN,
  'manage:slots': ADMIN,
  'manage:enrollments': ADMIN,
  'manage:sessions': ADMIN,
  'run:billing': ADMIN,
  'manage:invoices': ADMIN,
  'manage:bookkeeping': ADMIN,
  'manage:students': ADMIN,
  'manage:clients': ADMIN,
  'manage:settings': ADMIN,
  'manage:members': ADMIN,
};

export const can = (role: MemberRole, p: Permission): boolean => PERMISSIONS[p].includes(role);
